interface TocKeyOptions {
  revisionId?: string | null;
  locale?: string;
  start?: unknown;
  stop?: unknown;
  currentPosition?: unknown;
  sectionSuperId?: string;
  headerHierarchy?: string[];
  sectionRevisionId?: string;
}

export const documentKeys = {
  listAll: ['DOCUMENTS'] as const,
  list: (filters: Record<string, unknown>) => ['DOCUMENTS', filters],
  detailAll: ['DOCUMENT'] as const,
  detailPrefix: (documentId: number | string) => ['DOCUMENT', documentId],
  bySuperId: (documentSuperId: number | string) => ['DOCUMENT', { documentSuperId }],
  detail: (documentId: number | string, selectedOrganization: unknown, revisionId?: string) => ['DOCUMENT', documentId, { selectedOrganization, revisionId }],
  toc: (opts: TocKeyOptions) => ['DOCUMENT', opts],
  revision: (revisionId: string | undefined, documentSuperId: number | string | undefined) => ['DOCUMENT', 'revision', { revisionId, documentSuperId }],
  sectionRevision: (sectionRevisionId: string) => ['DOCUMENT', 'section', { sectionRevisionId }],
  versionsAll: ['VERSIONS'] as const,
  versions: (documentId: number | string, draftDocument: unknown, documentRevisionId?: string) => [
    'VERSIONS',
    { documentId, draftDocument, documentRevisionId },
  ],
  simpleVersions: (documentId: number | string) => ['VERSIONS', 'simple', { documentId }],
  changesAll: ['DOCUMENT_CHANGES'] as const,
  changes: (documentId: number | string, fromDate: unknown, toDate: unknown) => ['DOCUMENT_CHANGES', { documentId, fromDate, toDate }],
  paragraphHistory: (documentId: number | string, sectionId: string, revisionL: unknown, revisionR: unknown, nodeId: unknown) => [
    'PARAGRAPH_HISTORY',
    { documentId, sectionId, revisionL, revisionR, nodeId },
  ],
  image: (revisionId: string | undefined) => ['image', revisionId],
  imagesAll: ['images'] as const,
  imagesBatch: (documentSuperId: number | string, imageType: string, index: number, chunk: string[]) => ['images', documentSuperId, imageType, index, chunk],
  pagesAll: ['PAGES'] as const,
  sectionPages: (documentRevisionId: string | undefined, sectionRevisionIds: unknown) => ['PAGES', { documentRevisionId, sectionRevisionIds }],
  editorDocument: (documentId: number | string, revisionId?: string, useDraft?: boolean, withStyle?: unknown) => [
    'DOCUMENT',
    documentId,
    { editor: true, revisionId, useDraft, withStyle },
  ],
  editorSectionAll: ['EDITOR_SECTION'] as const,
  editorSection: (sectionRevisionId: string) => ['EDITOR_SECTION', sectionRevisionId],
};
